"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _CodeSnippet = _interopRequireWildcard(require("../CodeSnippet"));

var _utils = require("../../utils");

var _excluded = ["children", "className", "inline", "copyable", "numbered"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @deprecated Code component is deprecated. Use CodeSnippet component or inline `<code>` instead.
 */
var Code = function Code(_ref) {
  var children = _ref.children,
      className = _ref.className,
      inline = _ref.inline,
      copyable = _ref.copyable,
      numbered = _ref.numbered,
      props = _objectWithoutProperties(_ref, _excluded);

  if (_utils.IS_DEV) {
    console.warn("Code component is deprecated. Use CodeSnippet component or inline `<code>` instead.");
  }

  if (inline) {
    return /*#__PURE__*/_react.default.createElement("code", _extends({
      className: className
    }, props), children);
  } else {
    var appearance = null;

    if (numbered) {
      appearance = _CodeSnippet.CodeSnippetBlockAppearance.NUMBERED;
    } else if (copyable) {
      appearance = _CodeSnippet.CodeSnippetBlockAppearance.LINUX_PROMPT;
    }

    return /*#__PURE__*/_react.default.createElement(_CodeSnippet.default, {
      blocks: [{
        appearance: appearance,
        code: children
      }]
    });
  }
};

Code.propTypes = {
  children: _propTypes.default.string.isRequired,
  inline: _propTypes.default.bool,
  copyable: _propTypes.default.bool,
  numbered: _propTypes.default.bool
};
var _default = Code;
exports.default = _default;